import utils from '../utils/index'

const defaultConfig = {
  delay: 100,
  interval: 20,
  threshold: 20,
  step: 10
}

export default function (superClass) {
  return class extends superClass {
    constructor(...arg) {
      // @ts-ignore
      super(...arg)

      this["ExtentAutoChange@scrollTimeout"] = null
    }

    install() {
      super.install()
    }

    destroy() {
      super.destroy()
    }

    requestAutoScroll(clientX, clientY, config) {
      config = utils.assign({}, defaultConfig, config)

      let box = this.svg.getBoundingClientRect()
        , dx, dy

      if (clientX - box.left < config.threshold) {
        dx = config.step
      } else if (box.right - clientX < config.threshold) {
        dx = -config.step
      } else {
        dx = 0
      }

      if (clientY - box.top < config.threshold) {
        dy = config.step
      } else if (box.bottom - clientY < config.threshold) {
        dy = -config.step
      } else {
        dy = 0
      }

      if ((dx || dy) && !this["ExtentAutoChange@scrollTimeout"]) {
        let scroll = () => {
          this.doScroll(dx, dy)
          this["ExtentAutoChange@scrollTimeout"] = setTimeout(scroll, config.interval)
        }

        this["ExtentAutoChange@scrollTimeout"] = setTimeout(scroll, config.delay)
      } else if ((!dx) && (!dy) && this["ExtentAutoChange@scrollTimeout"]) {
        this.cancelAutoScroll()
      }


    }

    cancelAutoScroll() {
      clearTimeout(this["ExtentAutoChange@scrollTimeout"])
      this["ExtentAutoChange@scrollTimeout"] = null
    }

    doScroll(dx, dy) {
      this.changeMatrix([...this.matrix.slice(0, 4), this.matrix[4] + dx, this.matrix[5] + dy])
    }
  }
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/Layers/ExtentAutoChangableMixin.js